import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { captureAdsAttribution, captureJobseaReferralIfPresent } from "./libs/analytics";
import { stashSelectedPlanFromSearch } from "./libs/selected-plan";
import { router } from "./router";

// Stamp the jobsea attribution flag from the current URL before React mounts.
// This must run on every initial page load (hard-nav / refresh / new tab) so
// that any landing on careerbldr.com from `resumebuilder.job-sea.com` — even
// pages other than /auth/register — gets credited if the user later registers.
captureJobseaReferralIfPresent();
captureAdsAttribution();
// Same for a pricing CTA `?plan=` — OAuth leaves this origin, so the choice
// has to live in sessionStorage before GitHub/Google bounce.
stashSelectedPlanFromSearch();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
